const UserInfoTypes = {
    USER_INFO_TYPE: "USER_INFO_TYPE"
}

export { UserInfoTypes };